export const shiftRangeSelection = (
  lastSelectedRow: number,
  index: number,
  currentSet: Set<number>
) => {
  // Shift Range selection: select all rows between lastSelectedRow and current index
  const start = Math.min(lastSelectedRow, index);
  const end = Math.max(lastSelectedRow, index);

  // Clear current selection and add the range
  currentSet.clear();
  for (let i = start; i <= end; i++) {
    currentSet.add(i);
  }
};

export const multiSelect = (
  index: number,
  currentSet: Set<number>,
  setLastSelectedRow: (value: number | null) => void
) => {
  // Multi-select mode: toggle the clicked row
  if (currentSet.has(index)) {
    currentSet.delete(index);
  } else {
    currentSet.add(index);
  }
  setLastSelectedRow(index);
};

export const selectOne = (
  index: number,
  currentSet: Set<number>,
  setLastSelectedRow: (value: number | null) => void
) => {
  if (currentSet.has(index) && currentSet.size === 1) {
    // If clicking the only selected row, deselect it
    currentSet.clear();
    setLastSelectedRow(null);
  } else {
    // Select only this row (clear others)
    currentSet.clear();
    currentSet.add(index);
    setLastSelectedRow(index);
  }
};

export const createRowClickHandler = (
  setHighlightedRows: (value: Set<number>) => void,
  setLastSelectedRow: (value: number | null) => void,
  lastSelectedRow: number | null,
  highlightedRows: Set<number>
) => {
  return (index: number, event: React.MouseEvent) => {
    const newSet = new Set(highlightedRows);
    // Check modifier keys, ctrlKey for Windows/Linux, metaKey for Mac, we want same functionality
    const isMultiSelect = event.ctrlKey || event.metaKey;
    const isRangeSelect = event.shiftKey;

    if (isRangeSelect && lastSelectedRow !== null) {
      // Range selection mode: select all rows between lastSelectedRow and current index
      shiftRangeSelection(lastSelectedRow, index, newSet);
    } else if (isMultiSelect) {
      // Multi-select mode: toggle the clicked row
      multiSelect(index, newSet, setLastSelectedRow);
    } else {
      // Normal mode: select only the clicked row, unselect others
      selectOne(index, newSet, setLastSelectedRow);
    }

    setHighlightedRows(newSet);
  };
};
